import { BrowserRouter, Route } from 'react-router-dom';

import Cart from 'cart/AppLoader';
import Checkout from 'checkout/AppLoader';
import ClubList from 'club/List';
import ClubRedirect from 'club/SignupRedirect';
import ClubSignup from 'clubSignup/AppLoader';
import {
  getProfileBase,
  getProductBase,
  getReservationBase,
  getCheckoutBase,
  getCollectionBase,
  getCartBase,
  getClubBase
} from 'common/helpers/routerHelper';
import Collection from 'products/CollectionLoader';
import Product from 'products/ProductLoader';
import Profile from 'profile/AppLoader';
import ReservationAvailability from 'reservation/AppLoader';
import ReservationTypeAvailability from 'reservation/TypeAppLoader';
import ReservationCart from 'reservationCart/AppLoader';

import ScrollToTop from './common/components/routes/ScrollToTop';
import URLHistory from './common/components/routes/UrlHistory';

const BrowserRoutes = () => (
  <BrowserRouter>
    <Route exact={false} path={getCartBase()} component={Cart} />
    <Route
      exact={false}
      path={`${getCheckoutBase()}/cart`}
      component={Checkout}
    />
    <Route
      exact={false}
      path={`${getCheckoutBase()}/club`}
      component={ClubSignup}
    />
    <Route
      exact={false}
      path={`${getCheckoutBase()}/reservation`}
      component={ReservationCart}
    />
    <Route exact path={getClubBase()} component={ClubList} />
    <Route
      exact={false}
      path={`${getClubBase()}/:slug`}
      component={ClubRedirect}
    />
    <Route
      exact={false}
      path={`${getCollectionBase()}/:slug`}
      component={Collection}
    />
    <Route
      exact={false}
      path={`${getProductBase()}/:slug`}
      component={Product}
    />
    <Route exact={false} path={getProfileBase()} component={Profile} />
    <Route
      exact
      path={getReservationBase()}
      component={ReservationAvailability}
    />
    <Route
      exact={false}
      path={`${getReservationBase()}/type/:slug`}
      component={ReservationTypeAvailability}
    />
    <ScrollToTop />
    <URLHistory />
  </BrowserRouter>
);

export default BrowserRoutes;
